import React from "react";
import "../../ModalLinkCreation/Blocks/ThumbnailPicker/Thumbnail.scss";

const IntegratedLargeThumbnail = ({ link }) => {
  return (
    <a href={link.LinkUrl} target="_blank" rel="noopener noreferrer">
      <div
        className="integrated-large-thumbnail-prev"
        style={{ backgroundImage: `url(${link.LinkImage})` }}
      >
        <div className="title-thumbnail">
          <div>{link.LinkTitle}</div>
        </div>
      </div>
    </a>
  );
};

export default IntegratedLargeThumbnail;
